module.exports = __webpack_public_path__ + "static/media/BrownEveningSun.caa788f8.jpg";